module.exports = __webpack_public_path__ + "static/img/bg-history.996009b7.jpg";